/* Shared scroll behavior for the captured theme and local product templates. */
(() => {
  const header = document.querySelector('.lcg-header, body > header.header');
  if (!header) return;
  let shell = header.closest('.shopify-section');
  if (!shell) {
    shell = document.createElement('div');
    const benefits = document.querySelector('.product-benefits');
    (benefits || header).before(shell);
    if (benefits) shell.append(benefits);
    shell.append(header);
  }
  shell.classList.add('local-scroll-header');
  let queued = false, shellHeight = 0, announcementHeight = 0;
  const rootStyle=document.documentElement.style;
  function setStyle(style,name,value){if(style.getPropertyValue(name)!==value)style.setProperty(name,value);}
  function setBottom(){setStyle(rootStyle,"--local-header-bottom",`${shellHeight-(shell.classList.contains("local-header-scrolled")?announcementHeight:0)}px`);}
  function measure() {
    const announcement=shell.querySelector('.lcg-header__benefits, .product-benefits');
    const height=announcement?.offsetHeight||0, full=shell.offsetHeight;
    announcementHeight=height;shellHeight=full;
    setStyle(shell.style,'--local-announcement-height',height+'px');setBottom();
  }
  function reveal() { shell.classList.remove('local-header-hidden'); }
  function update() {
    queued = false;
    const y = Math.max(0, Math.min(scrollY, document.documentElement.scrollHeight - innerHeight));
    shell.classList.toggle('local-header-scrolled', y > shellHeight);
    // Keep search and navigation accessible in both scroll directions.
    reveal();
    setBottom();
  }
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, {passive: true});
  window.addEventListener('resize', measure, {passive: true});
  shell.addEventListener('focusin', reveal);
  document.addEventListener('cabane:menu-open', reveal);
  new ResizeObserver(measure).observe(shell);
  measure();
  update();
})();

